import parse from 'html-react-parser';
import { t } from 'i18next';
import { IErrorObject, IErrorResponse, Order } from './contracts';

export const clientConfig = {
    cloudinaryFolder: process.env.REACT_APP_CLOUDINARY_FOLDER || 'production',
    pricingEnvironment: process.env.REACT_APP_PRICING_ENV || 'production',
    howItWorksWp: process.env.REACT_APP_WP_HOW_IT_WORKS,
    mainLandingPageWp: process.env.REACT_APP_WP_MAIN_LANDING_PAGE,
    apiBaseUrl: process.env.REACT_APP_HOST,
}

export const InspectorPublicMenus = [
    {
        name: 'MENU_CONTACT',
        path: '/contact',
        footerOrder: 5,
        order: 5,
    },
    {
        name: 'TERMS_OF_USE',
        path: 'https://designbuilder.co.il/policy/',
        order: 7,
        external: true,
        footerOrder: 4,
        removeFromHeader: true,
    },
    {
        name: 'DESIGN_BUILDER',
        path: 'https://designbuilder.co.il/',
        order: 8,
        footerOrder: 1,
        external: true,
        removeFromHeader: true,
    },
    
]
export const PublicMenus = [
    {
        name: 'MENU_CONTACT',
        path: '/contact',
        footerOrder: 5,
        order: 5,
    },
    {
        name: 'MENU_HOW_IT_WORKS',
        path: '/how-it-works',
        footerOrder: 2,
        order: 4,
    },
    {
        name: 'MENU_PRICING',
        path: '/pricing',
        order: 9,
        footerOrder: 3,
        removeFromHeader: true,
    },
    {
        name: 'TERMS_OF_USE',
        path: 'https://designbuilder.co.il/policy/',
        order: 7,
        external: true,
        footerOrder: 4,
        removeFromHeader: true,
    },
    {
        name: 'DESIGN_BUILDER',
        path: 'https://designbuilder.co.il/',
        order: 8,
        footerOrder: 1,
        external: true,
        removeFromHeader: true,
    },
]

export const PrivateMenus = [
    {
        name: 'MENU_DASHBOARD',
        path: '/',
        order: 1,
    },
    // {
    //     name: 'MENU_MY_CHECKS',
    //     path: '/checks',
    //     order: 1.5,
    // },
    {
        name: 'MENU_EDIT_USER',
        path: '/edit/user',
        order: 2,
    },
    {
        name: 'MENU_BUSINESS',
        path: '/edit/business',
        order: 3,
    },
    // {
    //     name: 'MENU_CAD2DXF',
    //     path: '/cad-to-dxf',
    //     order: 4,
    // },
]

export const InspectorMenus = [
    {
        name: 'MENU_DASHBOARD',
        path: '/dashboard',
        order: 2,
    },
    {
        name: 'MENU_INSPECTIONS',
        path: '/inspections',
        order: 1,
    },
    // {
    //     name: 'MENU_CAD2DXF',
    //     path: '/cad-to-dxf',
    //     order: 1.5,
    // },
    {
        name: 'MENU_EDIT_USER',
        path: '/edit/user',
        order: 3,
    },
    {
        name: 'MENU_BUSINESS',
        path: '/edit/business',
        order: 4,
    },
]



export const AdminMenus = [
    {
        name: 'MENU_ADMIN_DASHBOARD',
        path: '/admin/dashboard',
        order: 1,
    },
    {
        name: 'MENU_ADMIN_INSPECTIONS',
        path: '/admin/inspections',
        order: 2,
    },
    {
        name: 'MENU_ADMIN_USERS',
        path: '/admin/users',
        order: 3,
    },

    {
        name: 'MENU_ADMIN_PROJECTS',
        path: '/admin/projects',
        order: 4,
    },
   
    {
        name: 'MENU_ADMIN_REVISIONS',
        path: '/admin/revisions',
        order: 5,
    },
   
    {
        name: 'MENU_ADMIN_TRANSACTIONS',
        path: '/admin/transactions',
        order: 6,
    },
    {
        name: 'MENU_ADMIN_STATS',
        path: '/admin/stats',
        order: 7,
    },
    {
        name: 'MENU_ADMIN_TICKETS',
        path: '/admin/tickets',
        order: 8,
    },
    // {
    //     name: 'MENU_CAD2DXF',
    //     path: '/admin/cad-to-dxf',
    //     order: 9,
    // },

   
]

export function getAuthorization({ auth, user, organizations }: any) {
    let authorization
    if (!user || !user.organizationId) {
        return null
    }
    const organization = organizations[user.organizationId]
    if (!organization) {
        return null
    }

    const members = organization.members || []
    for (let i = 0; i < members.length; i++) {
        let member = members[i]
        if (auth && user && member.id === auth.id) {
            authorization = member.authorization
            break
        }
    }
    return authorization
}

export const RemoveAllLoggedInUsersData = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    localStorage.removeItem('organizations')
    localStorage.removeItem('auth')
    localStorage.removeItem('language')
    localStorage.removeItem('role')
    localStorage.removeItem('organizationId')
}

export function monthDiff(d1: any, d2: any) {
    let fromDate = d1
    let toDate = d2
    if (typeof fromDate === 'string') {
        fromDate = new Date(d1)
    }
    if (typeof toDate === 'string') {
        toDate = new Date(d2)
    }
    let months
    months = (toDate.getFullYear() - fromDate.getFullYear()) * 12
    months -= fromDate.getMonth() + 1
    months += toDate.getMonth()
    return months <= 0 ? 0 : months
}

export function calcCreditedPoints(transaction: any) {
    if (transaction.monthly === true) {
        let diffInMonths = monthDiff(transaction.createdAt, new Date())
        return (diffInMonths + 1) * (transaction.points / 12)
    } else {
        return transaction.points
    }
}

export function calcTotalAccountPoints(organization: any) {
    if (!organization) {
        return 0
    }
    const { transactions } = organization
  

    let list = []
    for (let property in transactions) {
        if (transactions.hasOwnProperty(property)) {
            list.push(transactions[property])
        }
    }



    let points = 0
    list &&
        list
            .filter((a) => a.status === 'success')
            .sort((a, b) => b.createdAt - a.createdAt)
            .forEach((transaction) => {
                if (
                    transaction.type == 'CREDIT'
                ) {
                    points += calcCreditedPoints(transaction)
                } else if (
                    transaction.type == 'DEBIT'
                ) {
                    if (!transaction.usedPowerCredits) {
                        points -= transaction.points

                    }
                }
            })
    return points
}

/** True when the org can launch a simulation (unlimited membership or remaining credits). */
export const orgCanRunSimulation = (
  organization?: { hasUnlimited?: boolean; totalCredits?: number; transactions?: unknown } | null
): boolean => {
  if (!organization) return false;
  if (organization.hasUnlimited) return true;
  const credits =
    organization.totalCredits != null
      ? Number(organization.totalCredits)
      : calcTotalAccountPoints(organization);
  return Number.isFinite(credits) && credits > 0;
};

export const totalDebitPoints = (organization: any) => {
    const { transactions } = organization
    let totalDebits = 0

    for (let property in transactions) {
        if (transactions.hasOwnProperty(property)) {
            const transaction = transactions[property]
            if (
                transaction.type === 'DEBIT' &&
                transaction.status === 'success'
            ) {
                totalDebits += transaction.points || 0
            }
        }
    }

    return totalDebits
}

export const GetUserOrganization = (organization: any, user: any) => {
    return organization && user && user.organizationId
        ? organization[`${user.organizationId}`]
        : ''
}

export const ellipsis = (value: any, size: any) => {
    return value && value.length > size
        ? value.substring(size - 3, 0) + '...'
        : value || ''
}

export const getErrorHtmlContent = (error: IErrorResponse) => {
    let errorHtml = []

    if (error.ServerErrorCode) {
        errorHtml = error.ServerErrorCode.map((code) => generateErrorHTML(code))
    } else {
        errorHtml = [`<span>${t('GENERAL_ERROR')}</span>`]
    }
    return parse(`<div class="errorsNotistack"> ${errorHtml.join('')} </div>`)
}

const generateErrorHTML = (errorObj: IErrorObject) => {
    
    return `<span class="errorSpan"> ${t(errorObj.code)}</span>\n`
}

/**
 * Extracts and translates error message from IErrorResponse object
 * @param error - The error response object from axios interceptor
 * @param defaultMessage - Fallback message if no error code is found
 * @param translateFn - Optional translation function (defaults to i18next t function)
 * @returns Translated error message string
 */
export const getErrorMessage = (
    error: IErrorResponse | null | undefined, 
    defaultMessage: string,
    translateFn?: (key: string) => string
): string => {
    if (!error) return defaultMessage;
    
    const translate = translateFn || t;
    
    // Helper to safely convert error code to string
    // Handles cases where error code might be an object (e.g., { message: 'ERROR_CODE' })
    const getErrorCodeString = (code: any): string | null => {
        if (typeof code === 'string') return code;
        if (typeof code === 'object' && code !== null) {
            // If it's an object, try to extract message or details
            // This handles cases where backend returns { message: 'ERROR_CODE' } or nested objects
            if (code.message !== undefined) {
                const msg = code.message;
                // If message is a string, return it; if it's another object, recurse
                if (typeof msg === 'string') return msg;
                if (typeof msg === 'object' && msg !== null) {
                    return getErrorCodeString(msg);
                }
            }
            if (code.details !== undefined) {
                const details = code.details;
                if (typeof details === 'string') return details;
                if (typeof details === 'object' && details !== null) {
                    return getErrorCodeString(details);
                }
            }
            // If it's an object but no message/details, return null (fallback to default)
            return null;
        }
        return code ? String(code) : null;
    };
    
    // Helper to ensure we always return a string
    const safeTranslate = (code: string): string => {
        try {
            const translated = translate(code);
            // Ensure translated value is a string
            if (typeof translated === 'string') {
                return translated !== code ? translated : defaultMessage;
            }
            return defaultMessage;
        } catch (e) {
            return defaultMessage;
        }
    };
    
    // Check ServerErrorCode array first (most common case)
    if (error?.ServerErrorCode && error.ServerErrorCode.length > 0) {
        // Use the first error code and translate it
        const errorCodeRaw = error.ServerErrorCode[0].code;
        const errorCode = getErrorCodeString(errorCodeRaw);
        
        if (errorCode) {
            return safeTranslate(errorCode);
        }
    }
    
    // Fallback to GeneralErrorCode
    if (error?.GeneralErrorCode) {
        const errorCode = getErrorCodeString(error.GeneralErrorCode);
        if (errorCode) {
            return safeTranslate(errorCode);
        }
    }
    
    // Fallback to response message if available
    const apiMessage = error?.actualError?.response?.data?.message || error?.actualError?.response?.data?.details;
    if (apiMessage) {
        const messageStr = getErrorCodeString(apiMessage);
        if (messageStr) {
            return safeTranslate(messageStr);
        }
    }
    
    return defaultMessage;
}

export const processTextWithLinks = (text: string): string => {
    const urlRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+)|\b([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?/g;

    // Diviser le texte en lignes
    const lines = text.split('\n');

    // Traiter chaque ligne séparément
    const processedLines = lines.map(line => {
        return line.replace(urlRegex, (match) => {
            let url = match;
            if (!url.startsWith('http://') && !url.startsWith('https://')) {
                url = 'https://' + url;
            }
            return `<a href="${url}" target="_blank" rel="noopener noreferrer">${match}</a>`;
        });
    });

    // Rejoindre les lignes avec des balises <br> pour les sauts de ligne
    return processedLines.join('<br>');
};

export const getRevisionErrorHtmlContent = (errorMessages: any) => {
    let errorHtml = []
        if (errorMessages.message.length > 0) {
        if(errorMessages.type_message == "ticket"){
            errorHtml = errorMessages.message.map((message) => `<span>${(message)}</span>`)
        }else{
            errorHtml = errorMessages.message.map((message) => `<span>${t(message)}</span>`)
        }
    } else {
        errorHtml = [`<span>${t('GENERAL_ERROR')}</span>`]
    }
    return parse(`<div class="errorsNotistack"> ${errorHtml.join('<div></div>')} </div>`)
}



export function stableSort<T>(
    array: readonly T[],
    comparator: (a: T, b: T) => number
) {
    const stabilizedThis = array.map((el, index) => [el, index] as [T, number])
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0])
        if (order !== 0) {
            return order
        }
        return a[1] - b[1]
    })
    return stabilizedThis.map((el) => el[0])
}


interface IFile {
    idf: {
        file: File | null;
        name: string;
    };
}

interface IRevision {
    id: string;
    index: number;
    createdBy: string;
    updatedAt: Date;
    status: string;
    type: string;
    points: number;
    files: IFile;
    // Ajoutez d'autres propriétés si nécessaire
}
export function getComparator<Key extends keyof any>(
    order: Order,
    orderBy: Key
): (a: { [key in Key]: any }, b: { [key in Key]: any }) => number {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy)
}

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
    const aValue = a[orderBy]
    const bValue = b[orderBy]
    if (orderBy === 'credit') {
        const totalPointsA = calcTotalAccountPoints(a)
        const totalPointsB = calcTotalAccountPoints(b)
        return totalPointsB - totalPointsA
    }
    if (orderBy === 'file_name') {
        return (a as any).files.idf.name.localeCompare((b as any).files.idf.name);
    }
    if (orderBy === 'purchased') {
        const totalPointsA = calcTotalAccountPoints(a) + totalDebitPoints(a)
        const totalPointsB = calcTotalAccountPoints(b) + totalDebitPoints(b)
        return totalPointsB - totalPointsA
    }
    if (aValue == null && bValue == null) {
        return 0
    }
    if (aValue == null) {
        return 1
    }
    if (bValue == null) {
        return -1
    }

    if (typeof aValue === 'string' && typeof bValue === 'string') {
        return (bValue as string).localeCompare(aValue as string)
    }
    if (typeof aValue === 'boolean' && typeof bValue === 'boolean') {
        return (bValue ? 1 : 0) - (aValue ? 1 : 0)
    }
    if (bValue < aValue) {
        return -1
    }
    if (bValue > aValue) {
        return 1
    }
    return 0
}


export const formatNumber = (num: number) => {
    return num?.toLocaleString('en-US');
  };

export const getUnlimitedPackageName = (packageId: string | null, t: any) => {
  if (!packageId) return '';
  const packageNames: { [key: string]: string } = {
    'PACKAGE_UNLIMITED_1D': t('PACKAGE_UNLIMITED_1D'),
    'PACKAGE_UNLIMITED_1M': t('PACKAGE_UNLIMITED_1M'),
    'PACKAGE_UNLIMITED_6M': t('PACKAGE_UNLIMITED_6M'),
    'PACKAGE_UNLIMITED_1Y': t('PACKAGE_UNLIMITED_1Y'),
    'PACKAGE_UNLIMITED_2Y': t('PACKAGE_UNLIMITED_2Y'),
    'PACKAGE_UNLIMITED_3Y': t('PACKAGE_UNLIMITED_3Y')
  };
  return packageNames[packageId] || packageId;
};

export const isUnlimitedPackage = (packageId: string) => {
  return packageId && packageId.startsWith('PACKAGE_UNLIMITED_');
};

// Get the latest expiry date from all unlimited subscriptions (including cancelled/expired)
// For cancelled subscriptions, uses cancelledAt as the limit date
// For non-cancelled subscriptions, uses expiry_date as the limit date
export const getLatestExpiryDate = (organization: any): Date | null => {
  if (!organization?.transactions) {
    return null;
  }
  
  const transactions = Object.values(organization.transactions || {}) as any[];
  
  // Get all unlimited CREDIT transactions
  const unlimitedTransactions = transactions.filter((transaction: any) => 
    transaction.unlimited === true &&
    transaction.type === 'CREDIT'
  );
  
  if (unlimitedTransactions.length === 0) return null;
  
  // Extract limit dates: cancelledAt for cancelled, expiry_date for others
  const limitDates = unlimitedTransactions
    .map((transaction: any) => {
      if (transaction.status === 'cancelled' && transaction.cancelledAt) {
        return new Date(transaction.cancelledAt);
      } else if (transaction.status === 'success' && transaction.expiry_date) {
        return new Date(transaction.expiry_date);
      }
      return null;
    })
    .filter((date: Date | null) => date !== null) as Date[];
  
  if (limitDates.length === 0) return null;
  
  // Return the most recent limit date
  return new Date(Math.max(...limitDates.map(date => date.getTime())));
};